var map = {
	"./genesis_logo.jpg": 85,
	"./gradelink_logo.jpg": 177,
	"./infinite_campus_logo.jpg": 88,
	"./powerschool_logo.jpg": 87,
	"./realtime_logo.jpg": 86,
	"./skyward_logo.jpg": 95
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;